import { render } from "./List.vue?vue&type=template&id=fd118dcc&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=fd118dcc&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-fd118dcc"

export default script